import { render, staticRenderFns } from "./PopupEditEvents.vue?vue&type=template&id=566ede70&scoped=true&"
import script from "./PopupEditEvents.vue?vue&type=script&lang=js&"
export * from "./PopupEditEvents.vue?vue&type=script&lang=js&"
import style0 from "./PopupEditEvents.vue?vue&type=style&index=0&id=566ede70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ede70",
  null
  
)

export default component.exports